import { DEFAULT_FONT_FAMILY } from 'common/constants';
import { SIZE } from 'common/sizes';
import styled from 'styled-components';

export const Button = styled.button`
    border-width: 0;
    border-radius: 5px;
    width: ${SIZE.TWENTYTHREE}px;
    height: ${SIZE.FOUR + SIZE.HALF}px;
    flex-grow: 0;
    margin-top: ${SIZE.SIX}px;
    background-color: #4da0ff;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);

    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;

    &:disabled {
        background-color: #bdbdbd;
        border: none;
    }

    &:hover {
        cursor: pointer;
    }
}
`

export const Image = styled.div`
    margin-bottom: ${SIZE.FOUR}px;
    left: -${SIZE.SIX}px;
`

export const Message = styled.div`
    font-family: Rubik;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #000000;
`

export const Title = styled.div`
    width: 190px;
    height: 45px;
    flex-grow: 0;
    margin: 0px 0px 0px 0px;
    padding: 0px 0px 0px 0px;
    font-family: Rubik;
    font-size: 26px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #272727;
`

export const FilterSection = styled.div`
    margin: 0px 0px 0px 0px;
`

export const ChipsCol = styled.div`
  width:auto;
  display:inline-block;
  margin: 0 0 0 ${SIZE.TWO}px;
  font-family: Rubik;
`;

interface IRootProps {
    widthValue?: string;
    heightValue?: string;
    topValue?: string;
    leftValue?: string;
    rightValue?: string;
    rotationValue?: string;
    opacityValue?: number;
};

export const MarginContainer = styled.div`  
    padding: 0px 93px 0px 93px;
`;

export const TableMargin = styled.div`  
    display: flex;
    flex-direction: column;
    width: calc(100% - 100px);
    margin: 0px 0px 0px 50px;
`;

export const Root = styled.div`  
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12);
    background-color: #ffffff;
    width: 100%;
    position: relative;
    z-index: 20;
    border-radius: ${SIZE.HALF}px;
    padding: 0px 0px 0px 0px;
    margin: 0px 0px ${SIZE.ONE_AND_A_HALF}px 0px;
`;

export const BlankPage = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: ${SIZE.HUNDRED}px;
`

export const PageTitle = styled.div`
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 20px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #fefefe;
    margin: 0px 0px 0px 0px;
`

export const MainContainer = styled.div`
    margin: 0px 0px 0px 0px;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
`

export const BottomSpacer = styled.div`
    padding: 20px 0px;
`